import { Component, Input } from '@angular/core';
import { LocalStorageKeyEnum } from 'src/app/localStorage.key.enum';
import { UserService } from 'src/app/services/user.service';
import { ToastService } from 'src/app/services/toast.service';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { environment } from '../../.././environments/environment';
declare var google;
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  @Input() showEnvWarning: boolean;
  collapsed = false;
  public version = environment.buildTimestamp
  userWithOutPerm: boolean=false;

  constructor(
    private router: Router,
    private authService: AuthService,
    private userService: UserService,
    private toastService: ToastService,
  ) { }

  ngOnInit(){
    this.getPermission();
  }
  getPermission(){
    let permissions = JSON.parse(localStorage.getItem("PERMISSIONS"));
    if(permissions && (Object.keys(permissions.permissions).length === 0)){
      this.userWithOutPerm=true;
    }
  }
  refreshPermissions() {
    // Set Permissions
    this.userService.getIdentity().then(permissions => {
      if (Object.keys(permissions.permissions).length == 0 && permissions.role.toLowerCase() != 'admin') {
        this.toastService.showError('Access denied. Insufficient permissions!');
        this.router.navigate(['login']);
      } else {
        localStorage.setItem(LocalStorageKeyEnum.PERMISSIONS_DOT_ANNOTATION, JSON.stringify(permissions));
        // permissions are coming from backend with dot annotation, we move it into tree anotation here to save it in localstorage
        var perms = {};
        _.forEach(permissions.permissions, function (value, key) {
          _.set(perms, key, value);
        });
        localStorage.setItem(
          LocalStorageKeyEnum.PERMISSIONS,
          JSON.stringify({ role: permissions.role, permissions: perms })
        );
        location.reload();
      }
    }).catch(error => console.error(error));
  }

  logout() {
    google.accounts.id.disableAutoSelect();
    this.authService.logout();
    window.location.href = '/login';
  }

}
